/* ============================================================
   product-galerij.js — één groot beeld met voorbeelden ernaast
   (17-09-2026, Omnify).

   Vanaf 768 px toont de galerij één beeld tegelijk (`.slider__item.is-actief`)
   en staat links een kolom met kleine voorbeelden. Klikken op een voorbeeld,
   de pijlen op het grote beeld of pijl-omhoog/omlaag in de kolom wisselen het
   beeld.

   Onder 768 px doet dit script niets zichtbaars: daar is de juno-slider actief
   en is de kolom verborgen. De `is-actief`-klasse wordt dan alleen door CSS
   vanaf tablet gebruikt.

   Tint volgen: kiest de klant een tint (het potlood), dan springt het grote
   beeld naar het eerste beeld van die tint. product.js doet hetzelfde voor
   de mobiele slider; dit is de desktopkant.
   ============================================================ */
(() => {
  if (customElements.get('product-galerij')) return;

  class ProductGalerij extends HTMLElement {
    connectedCallback() {
      if (this.klaar) return;
      this.klaar = true;
      this.items = [...this.querySelectorAll('.slider--media-gallery .slider__item')];
      this.duimen = [...this.querySelectorAll('[data-duim]')];
      this.lijst = this.querySelector('.product-galerij__duimen');
      this.index = Math.max(0, this.items.findIndex((el) => el.classList.contains('is-actief')));

      this.addEventListener('click', (e) => {
        const duim = e.target.closest('[data-duim]');
        if (duim && this.contains(duim)) {
          this.toon(Number(duim.dataset.duim));
          return;
        }
        const pijl = e.target.closest('[data-galerij-stap]');
        if (pijl && this.contains(pijl)) this.toon(this.index + Number(pijl.dataset.galerijStap));
      });

      this.lijst?.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
        e.preventDefault();
        this.toon(this.index + (e.key === 'ArrowDown' ? 1 : -1), true);
      });

      const product = this.closest('.product');
      const varianten = product?.querySelector('variant-options.js-variant-options');
      varianten?.addEventListener('change', () => {
        if (window.matchMedia('(max-width: 767px)').matches) return;
        const radio = varianten.querySelector('input[type="radio"]:checked');
        const tint = (radio?.value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-');
        if (!tint) return;
        const k = this.items.findIndex((el) => el.dataset.tint === tint);
        if (k > -1) this.toon(k);
      });
    }

    toon(i, focus = false) {
      const n = this.items.length;
      if (!n) return;
      const nieuw = ((i % n) + n) % n;
      this.index = nieuw;

      this.items.forEach((el, k) => {
        const aan = k === nieuw;
        el.classList.toggle('is-actief', aan);
        // Een video die uit beeld gaat hoort niet door te spelen.
        if (!aan) el.querySelectorAll('video').forEach((v) => v.pause());
      });

      this.duimen.forEach((d, k) => {
        const aan = k === nieuw;
        d.classList.toggle('is-actief', aan);
        d.setAttribute('aria-current', aan ? 'true' : 'false');
      });

      /* Het gekozen voorbeeld in beeld houden binnen de kolom, zonder de pagina
         zelf te laten scrollen (daarom geen scrollIntoView). */
      const duim = this.duimen[nieuw];
      if (duim && this.lijst) {
        const boven = duim.offsetTop;
        const onder = boven + duim.offsetHeight;
        if (boven < this.lijst.scrollTop) this.lijst.scrollTop = boven;
        else if (onder > this.lijst.scrollTop + this.lijst.clientHeight) {
          this.lijst.scrollTop = onder - this.lijst.clientHeight;
        }
        if (focus) duim.focus({ preventScroll: true });
      }
    }
  }

  customElements.define('product-galerij', ProductGalerij);
})();
